module.exports = __webpack_public_path__ + "files/ec2e92db80919ebdc27c58bfcb0da183.png";